export default {
  bankTransfer: 'Virement bancaire',
  firstTitle: 'Veuillez sélectionner la devise du virement',
  secondTitle: 'Après le virement',
  bankTips:
    "Obtenez les informations du bénéficiaire et rendez-vous au guichet bancaire correspondant pour remplir l'ordre de virement. Veuillez vérifier attentivement votre orthographe.",
  receiverTitle: 'Informations du bénéficiaire',
  bankAttrEnum: {
    0: 'Numéro de compte',
    1: 'Numéro de routage',
    2: 'Nom du compte',
    3: 'Nom de la banque',
    4: 'Adresse de la banque',
    5: 'Code postal',
    6: 'Pays/Région',
    7: 'Type de compte',
    8: 'Remarque',
  },
  transferTips:
    "Vous pouvez nous informer de l'une des manières suivantes, et nous vérifierons cela dès que possible !",
  transferName: "Nom de l'émetteur",
  transferBank: "Banque de l'émetteur",
  transferNo: 'Numéro de référence',
  submit: 'Soumettre maintenant',
  successSubmit: 'Soumission réussie',
  successSubmitTips:
    "* En cas de problème lors de la vérification, nous contacterons votre adresse e-mail d'inscription acbuy.",
  tradeDetail: 'Détail de la transaction',
  backOrder: 'Retourner à la commande',
  holder: {
    inputNo: 'Veuillez fournir le numéro de référence si disponible.',
  },
  transferExplain: 'Instructions pour le virement bancaire :',
  transferExplainEnum: {
    0: 'acbuy ne facture pas de frais de traitement pour ce mode de paiement. La facturation de frais par la banque émettrice dépend des politiques correspondantes de cette banque.',
    1: 'Ce mode de paiement prend en charge plusieurs devises. Les clients peuvent choisir le compte bancaire correspondant pour le virement en fonction de leur région et de leurs besoins.',
    2: "Normalement, le délai d'arrivée est de 1 à 3 jours ouvrables ; dans des circonstances particulières, il faut compter 1 à 5 jours ouvrables.",
    3: "acbuy convertira le montant en RMB au taux de change d'acbuy lors de la réception du virement, puis le créditera sur votre compte.",
    4: 'Le montant final en RMB sur le compte acbuy = Le montant de votre virement * le taux de change de la plateforme acbuy.',
  },
}
